import React from "react";
import { bool, func, string, node } from "prop-types";
import { anonymousFunc } from "../../utils/helpers";

const LinkButton = ({
  loading,
  icon,
  onClick,
  label,
  additionalClass,
  disabled,
}) => {
  return (
    <button
      onClick={loading || disabled ? anonymousFunc : onClick}
      type="button"
      disabled={disabled || loading}
      className={`${disabled ? "co-gray" : "co-primary"} bg-white borderless ${additionalClass}`}
    >
      {icon && (
        <span
          style={{
            marginRight: "0.3rem",

            display: "inline-flex",
            alignItems: "center",
          }}
        >
          {icon}
        </span>
      )}
      <b>{label}</b>
    </button>
  );
};

LinkButton.propTypes = {
  onClick: func.isRequired,
  label: string.isRequired,
  additionalClass: string,
  loading: bool,
  disabled: bool,
  icon: node,
};

LinkButton.defaultProps = {
  additionalClass: "",
  icon: null,
  disabled: false,
};

export default LinkButton;
